import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatINR } from "../lib/api";
import { useShop } from "../context/ShopContext";
import { Package, RotateCw } from "lucide-react";
import { toast } from "sonner";

export default function AccountOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToCart } = useShop();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/account/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  const reorder = (order) => {
    order.items.forEach((i) => {
      addToCart({ id: i.product_id, slug: i.product_id, name: i.name, images: [i.image], price: i.price }, i.quantity);
    });
    toast.success("Items added to cart");
    navigate("/checkout");
  };

  return (
    <div data-testid="account-orders">
      <h2 className="font-display text-2xl uppercase tracking-tight">Your Orders</h2>
      <div className="divider-orange mt-3 mb-6" />
      {loading ? (
        <p className="text-white/50 font-body">Loading…</p>
      ) : orders.length === 0 ? (
        <div className="border border-white/10 py-16 text-center">
          <Package className="mx-auto text-white/30" size={36} />
          <p className="mt-3 text-white/55 font-body">No orders yet.</p>
          <Link to="/shop" className="btn-orange mt-5 inline-flex">Start Shopping</Link>
        </div>
      ) : (
        <ul className="space-y-4">
          {orders.map((o) => (
            <li key={o.order_number} data-testid={`order-${o.order_number}`} className="border border-white/10 p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <div className="font-display tracking-tight">Order #{o.order_number}</div>
                  <div className="text-xs text-white/50 font-body mt-1">{new Date(o.created_at).toLocaleString("en-IN")}</div>
                </div>
                <div className="text-right">
                  <div className="font-display text-[#D96A1B] text-lg">{formatINR(o.total)}</div>
                  <div className="text-[10px] uppercase tracking-widest font-display text-white/50 mt-1">{o.status}</div>
                </div>
              </div>
              <div className="mt-4 flex gap-3 overflow-x-auto">
                {o.items.map((i) => (
                  <div key={i.product_id} className="flex items-center gap-3 min-w-[220px] bg-white/5 p-2">
                    <img src={i.image} alt="" className="w-12 h-14 object-cover" />
                    <div className="flex-1">
                      <div className="text-xs font-display uppercase tracking-tight line-clamp-2">{i.name}</div>
                      <div className="text-[10px] text-white/50 font-body">Qty {i.quantity} · {formatINR(i.price)}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 text-xs text-white/50 font-body flex flex-wrap items-center justify-between gap-3">
                <span>Shipping to {o.address}, {o.city}, {o.state} – {o.pincode}</span>
                <button
                  data-testid={`reorder-${o.order_number}`}
                  onClick={() => reorder(o)}
                  className="inline-flex items-center gap-2 font-display tracking-widest uppercase text-xs text-[#D96A1B] hover:text-[#E87A2A] border border-[#D96A1B]/40 hover:border-[#D96A1B] px-3 py-1.5"
                >
                  <RotateCw size={12} /> Reorder
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
